import { useState, useEffect } from 'react';

/**
 * Custom hook to enable/disable debug mode via keyboard shortcuts
 * Type "varros" to enable debug mode
 * Type "nysse" to disable debug mode
 */
export const useDebugMode = () => {
    const [debugEnabled, setDebugEnabled] = useState(() => {
        // Check if debug mode was previously enabled (persisted in localStorage)
        const stored = localStorage.getItem('debugMode');
        return stored === 'true';
    });

    const [keyBuffer, setKeyBuffer] = useState('');

    useEffect(() => {
        const handleKeyPress = (event) => {
            // Only track letter keys, ignore when typing in input fields
            if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
                return;
            }

            const key = event.key.toLowerCase();
            if (key.length === 1 && /[a-z]/.test(key)) {
                const newBuffer = (keyBuffer + key).slice(-6); // Keep last 6 characters
                setKeyBuffer(newBuffer);

                // Check for activation sequence
                if (newBuffer === 'varros') {
                    setDebugEnabled(true);
                    localStorage.setItem('debugMode', 'true');
                    console.log('🔧 Debug mode enabled!');
                    setKeyBuffer(''); // Clear buffer after activation
                }
                // Check for deactivation sequence
                else if (newBuffer === 'nysse') {
                    setDebugEnabled(false);
                    localStorage.setItem('debugMode', 'false');
                    console.log('🚌 Debug mode disabled!');
                    setKeyBuffer(''); // Clear buffer after deactivation
                }
            }
        };

        window.addEventListener('keydown', handleKeyPress);
        return () => window.removeEventListener('keydown', handleKeyPress);
    }, [keyBuffer]);

    return debugEnabled;
};
